<template>
  <vf-color-picker v-bind="forwarded" :size />
</template>

<script lang="ts" setup>
import type { Props } from '#brands/components/vf/color-picker/ColorPicker.vue'
import VfColorPicker from '#brands/components/vf/color-picker/ColorPicker.vue'

const props = defineProps<Props>()

const { $feature } = useNuxtApp()
const { brandClasses, brandStyles } = useAppConfig().components.vf.colorPicker

let size = props.size

if ($feature.tempShowATCAboveFold) {
  size = {
    sm: 'md',
    lg: 'sm'
  }
  brandClasses.root = 'group relative flex center outline-none lg:rounded-md'
  brandClasses.rectangle.swatch = 'rounded hover:ring-2 hover:ring-black hover:dark:ring-white lg:hover:ring'
  brandClasses.rectangle.swatchActive = 'rounded ring-2 ring-black dark:ring-white lg:ring'
  brandStyles.rectangle.container!.h.sm = '4rem'
  brandStyles.rectangle.container!.w.sm = '4rem'
  brandStyles.rectangle.swatch!.inset.sm = '0.125rem'
  brandStyles.rectangle.swatchUnavailable!.inset.sm = '0.25rem'
}

const forwarded = useForwardProps(props)
</script>
